/// <amd-module name="Analytics/Shared/Analytics-Visuals-Common/ErrorComponent/ErrorComponent" />
import * as Resources from "Analytics/Shared/Analytics-Visuals-Common/Resources";
import { AnalyticsUnavailableMessage } from "Analytics/Shared/Visuals/Common/Components/AnalyticsUnavailableMessage";
import * as React from "react";

export interface IErrorProps {
    className?: string;
    errorMessage?: string;
}

export const ErrorComponent: React.SFC<IErrorProps> = props => {
    const { className, errorMessage } = props;
    return (
        <div className={className}>
            <AnalyticsUnavailableMessage
                message={Resources.ErrorMessage}
                suggestion={errorMessage && Resources.ErrorMessageSuggestion + Resources.ErrorDetails + errorMessage}
                iconName="ErrorBadge"
                messageClassName={"ax-unavailable-error-message"}
            />
        </div>
    );
};
